// @flow

import React from 'react';
import { Query, type QueryRenderProps } from '@apollo/client/react/components';
import {
  type GetClientLedgerData,
  type GetClientLedgerVariables,
  GET_CLIENT_LEDGER_ACCOUNTS,
} from 'client-web-app/queries';

import TransactionSidebarDataEntryRow from './TransactionSidebarDataEntryRow';
import type { JournalEntry } from './types';

type TransactionSidebarDataEntryRowContainerProps = {
  clientCategorizationSelectedLedgerId: ?string,
  currentLedgerId: ?string,
  dataEntryLedgerAccountId: string,
  ledgerNameTestId: string,
  clientId: string,
  transaction: JournalEntry,
  dataEntryAmountInCents: number,
};

const TransactionSidebarDataEntryRowContainer = ({
  clientCategorizationSelectedLedgerId,
  currentLedgerId,
  dataEntryLedgerAccountId,
  dataEntryAmountInCents,
  ledgerNameTestId,
  clientId,
  transaction,
}: TransactionSidebarDataEntryRowContainerProps) => (
  <Query query={GET_CLIENT_LEDGER_ACCOUNTS} variables={{ clientId }}>
    {({
      data,
      error,
      loading,
    }: QueryRenderProps<GetClientLedgerData, GetClientLedgerVariables>) => {
      if (loading || error) return null;

      const ledgerAccounts = (data && data.ledgerAccounts) || [];

      const ledgerAccountsMap = new Map();
      ledgerAccounts.forEach(ledgerAccount =>
        ledgerAccountsMap.set(ledgerAccount.id, ledgerAccount),
      );

      return (
        <TransactionSidebarDataEntryRow
          dataEntryAmountInCents={dataEntryAmountInCents}
          dataEntryLedgerAccountId={dataEntryLedgerAccountId}
          transaction={transaction}
          ledgerAccountsMap={ledgerAccountsMap}
          clientId={clientId}
          ledgerNameTestId={ledgerNameTestId}
          clientCategorizationSelectedLedgerId={clientCategorizationSelectedLedgerId}
          currentLedgerId={currentLedgerId}
        />
      );
    }}
  </Query>
);

export default TransactionSidebarDataEntryRowContainer;
